/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const useRecurringProfileInvoices = (id, page, queryParams) =>
  useQuery({
    queryKey: queryKeys.recurringProfiles.invoices(id, page),
    queryFn: () =>
      fetcher({
        method: "GET",
        url: "/public/invoice",
        params: { "filter[recurring_profile_id]": id, page, on_page: 10 },
      }),
    placeholderData: keepPreviousData,
    ...queryParams,
  });
